<template>
  <v-row justify="center">
    <v-dialog
      style="border-radius: 5px"
      v-model="show"
      persistent
      max-width="600px"
    >
      <custom-modal
        title="Stock Adjustment"
        @onSubmit="SaveAdjustment"
        @onClose="close"
        :isLoading="isLoading"
      >
        <ValidationObserver ref="observer" v-slot="{ validate, reset }">
          <v-row>
            <v-col cols="6">
              <ValidationProvider
                v-slot="{ errors }"
                name="Operator"
                rules="required"
                hide-details="auto"
              >
                <v-select
                  hide-details="auto"
                  :error-messages="errors"
                  required
                  v-model="StockAdjustmentModal.operator"
                  label="Operator"
                  item-text="name"
                  outlined
                  dense
                  :items="operations"
                ></v-select>
              </ValidationProvider>
            </v-col>

            <v-col cols="6">
              <ValidationProvider
                v-slot="{ errors }"
                name="Quantity"
                rules="required"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="StockAdjustmentModal.quantity"
                  label="Quantity"
                  outlined
                  type="number"
                  hide-details="auto"
                  step="any"
                  min="0"
                  :rules="[numberRule]"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
        </ValidationObserver>
      </custom-modal>
    </v-dialog>
  </v-row>
</template>
<script>
import { mapState } from 'vuex';
import { StockAdjustmentModal } from '@/models/StockEdit';
import CustomModal from '@/components/base/CustomModal';

import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';
import { IncomeCategory } from '@/models/IncomeCategory';
export default {
  data: () => ({
    dialog: false,
    StockAdjustmentModal: new StockAdjustmentModal(),

    value: [],
    options: [],
    numberRule: (val) => {
      if (val < 0) return 'Please enter a positive number';
    },
    operations: [
      { name: '+', value: '+' },
      { name: '-', value: '-' },
    ],
    isLoading: false,
  }),

  name: 'AddCategory',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    StockAdjustment: {
      type: Object,
      default: {},
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    CustomModal,
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close', this.StockAdjustment);
        }
      },
    },
  },
  methods: {
    close() {
      this.show = false;
      this.StockAdjustmentModal = new StockAdjustmentModal();

      this.$refs.observer.reset();
    },
    async SaveAdjustment() {
      //
      const isValid = await this.$refs.observer.validate();
      this.StockAdjustment.isAdd = true;

      if (isValid && this.StockAdjustmentModal.quantity > 0) {
        this.UpdateStockAdjustment();
      }
    },

    UpdateStockAdjustment() {
      let credential = this.StockAdjustmentModal;
      credential.wareHouse_id = this.StockAdjustment.warehouse_id;
      credential.product_id = this.StockAdjustment.product_id;
      credential.batch_id = this.StockAdjustment.batch_id;
      credential.unit_id = this.StockAdjustment.unit_id;
      this.isLoading = true;

      this.$store
        .dispatch('stock/UpdateStockDetailsWarehouse', credential)
        .then(async (res) => {
          this.succeeed = true;
          this.StockAdjustmentModal = new StockAdjustmentModal();
          this.$emit('afterSave');
          this.$toast.success('Stock updated successfully');
          //
          this.isLoading = false;
          this.show = false;

          this.$refs.observer.reset();
        })
        .catch((err) => {
          this.isLoading = false;
          this.$refs.observer.setErrors(err.data.error);

          this.$toast.error('Failed to update stock');
          this.isLoading = false;
        });
    },
  },
};
</script>
